import { UserGroup } from '@core/api/angular';

export const AdminRoles = [
  UserGroup.VICNAMES_ADMIN,
  UserGroup.SMES_ADMIN,
  UserGroup.VICNAMES_ADMIN,
  UserGroup.LASSI_ADMIN,
];

export const AllRoles = [
  {
    value: UserGroup.LASSI_ADMIN,
    label: 'LASSI Admin',
  },
  {
    value: UserGroup.SMES_ADMIN,
    label: 'SMES Admin',
  },
  {
    value: UserGroup.VICNAMES_ADMIN,
    label: 'VICNAMES Admin',
  },
  {
    value: UserGroup.DQA_ADMIN,
    label: 'DQA Admin',
  },
  {
    value: UserGroup.SMES_USER,
    label: 'SMES User',
  },
];
